import React, { useEffect } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Link';
import Menu from '@material-ui/core/Menu';
import Typography from '@material-ui/core/Typography';
import MenuItem from '@material-ui/core/MenuItem';
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state';
import { useTranslation } from 'react-i18next';
import MoreIcon from '@material-ui/icons/ExpandMore';
import { useFields, useOrganizations, useProperties, useSettings } from 'hooks';
import { BucketPeriods, BucketUnits } from 'utils/ReadingsHelpers';
import { DashboardHelpers } from 'utils';
import { CircularProgress } from '@mui/material';
import { grey } from '@mui/material/colors';

const FieldPicker = ({ variant, unsetLabel, unsetButtonLabel }) => {
  const { activeFields, fields, selectedField, setSelectedField, isFetchingFields, fetchFields } = useFields();
  const { selectedProperty, setSelectedProperty, isFetchingProperties } = useProperties();
  const { activeDashView } = useSettings();
  const { selectedOrganization, setSelectedOrganization } = useOrganizations();
  const { t } = useTranslation();
  const bucketDefault = {
    period: activeDashView == 'stats' ? BucketPeriods.Seven : BucketPeriods.Eight,
    unit: activeDashView == 'stats' ? BucketUnits.Days : BucketUnits.Hours,
    include_today: activeDashView == 'stats' ? false : true,
  };

  useEffect(() => {
    if (!isFetchingFields && (!fields || fields?.length === 0)) {
      fetchFields();
    }
  }, []);

  const getFieldItems = (popupState) => {
    const fieldItems = [
      <MenuItem
        key="none"
        onClick={(e) => {
          popupState.close(e);
          DashboardHelpers.setDefaultTelemetryPeriodByActiveTab(activeDashView);
          setSelectedField(undefined, {});
        }}
      >
        {t(unsetLabel)}
      </MenuItem>,
    ];
    _.forEach(activeFields, (field, fieldId) => {
      fieldItems.push(
        <MenuItem
          key={fieldId}
          onClick={(e) => {
            popupState.close(e);
            DashboardHelpers.setDefaultTelemetryPeriodByActiveTab(activeDashView);
            setSelectedField(field.id, bucketDefault);
            if (!selectedProperty) {
              setSelectedProperty(field.property_id);
            }
            if (selectedOrganization?.id !== field.organization_id && field.organization_id !== undefined) {
              setSelectedOrganization(field.organization_id);
            }
          }}
        >
          {field.name}
        </MenuItem>
      );
    });
    return fieldItems;
  };

  if (isFetchingProperties) {
    return <div />;
  }

  if (isFetchingFields) {
    return <CircularProgress color={grey[600]} size={20} />;
  }

  return (
    <PopupState variant="popover" popupId="field-popup-menu">
      {(popupState) => (
        <>
          <Button {...bindTrigger(popupState)}>
            <div style={{ display: 'flex' }}>
              <Typography variant={variant}>{selectedField ? selectedField.name : t(unsetButtonLabel)}</Typography>
              <MoreIcon fontSize="small" color="secondary" style={{ marginLeft: 4, marginTop: 4 }} />
            </div>
          </Button>
          <Menu {...bindMenu(popupState)}>{getFieldItems(popupState)}</Menu>
        </>
      )}
    </PopupState>
  );
};

FieldPicker.propTypes = {
  variant: PropTypes.string,
  unsetButtonLabel: PropTypes.string,
  unsetLabel: PropTypes.string,
  showDefault: PropTypes.bool,
};

FieldPicker.defaultProps = {
  variant: 'subtitle1',
  unsetButtonLabel: 'field_choose',
  unsetLabel: 'none',
  showDefault: false,
};
export default FieldPicker;
